module.exports = __webpack_public_path__ + "img/12d1600.680cae6d.jpg";